<script>
    import { onMount } from 'svelte';
    import { components } from '$lib/stores/shared.svelte.js'
    import { fade } from 'svelte/transition';
    import Logo from '$lib/images/logo-word.svg';
    import { navItems } from '$lib/stores/shared.svelte.js';
    // import bgVideo from '$lib/video/space-needle-lukas-rodriguez-hd_1280_720_30fps.mp4';
    // import bgVideo from '$lib/video/dark_ocean_rostislav_uzunov_2160_24fps.mp4';
    // import bgVideo from '$lib/video/mossy-stream_2160_30fps.mp4';
    // import Icon from '$components/icon.svelte';
	// import Socials from '$components/socials.svelte';
    let height = $state(0);
    let currentYear = $state( new Date().getFullYear());

    onMount(() => {
        components.footH = height;
    })

</script>
<!-- Disable iOS auto-blue-link phone number -->

<footer 
    class="f-row align-sb text-c"
    bind:offsetHeight={height}
    transition:fade
    >

    <ul class="contact f-col nobullets text-l">
        <li class="dark">Reach Out</li>
        <li>hello@kinetic.design</li>
        <li>+1 (206) 387-3018</li>
    </ul>

<!-- <Socials /> -->
 

	<ul class="map f-row gap-40 align-cc pady-16 responsive">
		{#each navItems as navItem (navItem.name)}
        <li class="f align-cc">
			<a href={navItem.path}><h4>{navItem.name}</h4></a>
			<!-- <ul>
                {#if navItem.dropdown}
                    {#each navItem.dropdown as dropdownItem (dropdownItem.name)}
                        <li class="dropdown">
                            <a href={dropdownItem.path}>{dropdownItem.name}</a>
                        </li>
                    {/each}
                {/if}
			</ul> -->
		</li>		
		{/each}
	</ul> 
    
    <span class="last f align2-c">
        Copyright © {currentYear} Kinetic Design LLC. All rights reserved. 
    </span>




</footer>


<style>
    /* Mobile First */

footer {
    gap: .5rem;
    /* padding: var(--main-pad-mobile); */
    padding: 1.75rem var(--space-xl);
    }

    footer ul.map {
        display: none;
    }

footer {
    position: relative;
    /* width: 100%; */
    min-height: 7.5rem;
    background-color: var(--footer-bg-color);
    font-family: 'Inter Variable', sans-serif;
    font-size: .625rem;
    font-weight: 300;
    /* padding: var(--main-pad); */
    /* align-items: baseline; *old */
    align-items: last baseline;
    gap: 2rem;
}
/* Maybe move some of these styles into utility classes */


ul {
    list-style-type: none;
    color: white;
}

li h4 {
    padding: .125rem 0;
    margin: 0;
    font-size: 1.125rem;
    font-weight: 200;
    white-space: nowrap;
}

ul.contact {
    font-size: .875rem;
}

.map {
    width: auto;
    font-size: .875rem;
    text-align: left;
}

.map li {
    padding: .025rem;
}

/*.map h4 {
    padding: .5rem 0;
} Adjust this if/when split out into columns */

.map a, .last {
    color: var(--footer-font-color);
}


.dark {color: #929292;}

.last {
        flex-flow: column-reverse;
        text-align: left;
        gap: 1rem;
        padding: .875rem 0;
        font-size: .875rem;
    }


@media (min-width: 768px) {
    
	footer {
        position: relative;
        width: 100%;
        min-height: 7.5rem;
        background-color: var(--footer-bg-color);
        font-family: 'Inter Variable', sans-serif;
		font-size: .625rem;
        font-weight: 300;
        align-items: last baseline;
        gap: 2rem;
	}

        footer ul.map {
        display: flex;
    }

    .last {
    width: fit-content;
    font-size: .725rem;
    letter-spacing: .021rem;
    /* white-space: nowrap; */
}
    
}
</style>